import { i18nSelectorMap } from '../../reducers/i18n'
import { AxiosError } from 'axios'
import { getPCErrorField } from '../../util/api_errors'
import React from 'react'
import { AuthActionTypes } from '../../actions/auth'

export type LoginError = {
  root: string[]
  inputs?: {
    email?: string
    password?: string
  }
}

export const getLoginError = (i18n: i18nSelectorMap, err: AxiosError, reqType: string): LoginError | null => {
  let loginErr: LoginError | null = null
  const errMsg: string[] = []
  const pcMsg = getPCErrorField(err, 'message')
  if (pcMsg) {
    errMsg.push(pcMsg)
  } else {
    errMsg.push(i18n('auth.error.unexpected'), i18n('auth.error.tryAgain'))
  }

  switch (reqType) {
    case AuthActionTypes.Reset:
      errMsg[0] = `${i18n('auth.error.reset')}: ${errMsg[0]}`
      loginErr = {
        root: errMsg,
      }
      break
    case AuthActionTypes.Forgot:
      // PD-135 - catch the specific "email invalid" error code and show
      // a different message in the event that error was not the problem,
      // so that users reporting problems can relay that for our troubleshooting.
      const code = getPCErrorField(err, 'code')
      switch (code) {
        case 'PC-API-AUTH-15':
          loginErr = {
            root: [i18n('auth.error.forgot')],
            inputs: {
              email: `${i18n('auth.forgot.email')} ${i18n('auth.error.tryAgain')}`,
            },
          }
          break
        default:
          errMsg[0] = `${i18n('auth.error.forgot')}: ${errMsg[0]}`
          loginErr = {
            root: errMsg,
          }
      }
      break
    default:
      errMsg[0] = `${i18n('auth.error.login')}: ${errMsg[0]}`
      loginErr = {
        root: errMsg,
      }
  }

  if (!loginErr.inputs) {
    const inputs = getPCErrorField(err, 'inputs')
    if (inputs) {
      loginErr.inputs = {
        email: inputs.email,
        password: inputs.password,
      }
    }
  }

  return loginErr
}

type LoginErrorMessageProps = {
  error: LoginError | null
}
export const LoginErrorMessage = ({ error }: LoginErrorMessageProps): JSX.Element | null => {
  if (!error) return null
  return (
    <div className="error">
      {error.root.map((err, index) => {
        return <p key={`err-${err}-${index}`}>{err}</p>
      })}
    </div>
  )
}
